import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Alert,
  Button,
  Field,
  Input,
  Spinner,
} from "../../design-system";
import { AuthShell } from "../../design-system/layout/AuthShell";
import { userForgetPassword } from "../../slices/thunks";

const selectState = createSelector(
  (state) => state.ForgetPassword,
  (state) => ({
    forgetError: state.forgetError,
    forgetSuccessMsg: state.forgetSuccessMsg,
  }),
);

const ForgetPasswordPage = () => {
  document.title = "Recuperar contraseña | Kronaly";
  const dispatch = useDispatch();
  const { forgetError, forgetSuccessMsg } = useSelector(selectState);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().email("Correo no válido").required("Introduce tu correo electrónico"),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, "/forgot-password"));
    },
  });

  const fieldError =
    validation.touched.email && validation.errors.email ? validation.errors.email : null;

  return (
    <AuthShell
      footer={
        <Link to="/login" style={{ color: "var(--kr-fg-link)", fontWeight: 600 }}>
          Volver al inicio de sesión
        </Link>
      }
    >
      <div className="kr-mb-4">
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "var(--kr-fg-strong)" }}>
          Recuperar contraseña
        </h1>
        <p style={{ margin: "6px 0 0", fontSize: 13, color: "var(--kr-fg-muted)" }}>
          Te enviaremos un enlace de recuperación al correo asociado a tu cuenta.
        </p>
      </div>

      {forgetError && <div className="kr-mb-3"><Alert tone="danger">{forgetError}</Alert></div>}
      {forgetSuccessMsg && <div className="kr-mb-3"><Alert tone="success">{forgetSuccessMsg}</Alert></div>}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
        }}
        className="kr-flex kr-col kr-gap-4"
        noValidate
      >
        <Field label="Correo electrónico" required error={fieldError}>
          <Input
            type="email"
            name="email"
            value={validation.values.email}
            onChange={validation.handleChange}
            placeholder="empleado@empresa.com"
            inputProps={{ onBlur: validation.handleBlur, autoComplete: "email" }}
            autoFocus
          />
        </Field>
        <Button variant="primary" size="lg" type="submit" fullWidth>
          Enviar enlace de recuperación
        </Button>
      </form>
    </AuthShell>
  );
};

export default ForgetPasswordPage;
